import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { useTranslations } from "@jti/ui/providers/useTranslations";

export const SticksProductUnavailable = () => {
  const { __ } = useTranslations();

  return (
    <AlertBanner
      tone="error"
      title={__("productdetails.sticks.error.title")}
      description={__("productdetails.sticks.error.description")}
    />
  );
};
